import { toast } from "react-toastify";
import { TOAST_TYPES_ENUM } from "enums";
import "./Toast.scss";

interface ToastProps {
  message: string;
  type: TOAST_TYPES_ENUM;
  id: string;
}

const Toast = ({ message, type, id }: ToastProps) => {
  const handleShowToast = () => {
    switch (type) {
      case TOAST_TYPES_ENUM.SUCCESS:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--success">Sukces</h2>
              <p className="toast-message">{message}</p>
            </div>
          ),
          type: "success",
          isLoading: false,
          closeButton: true,
          autoClose: 3000,
          className: "Toastify__toast--stacked",
        });
        break;
      case TOAST_TYPES_ENUM.ERROR:
        toast.update(id, {
          render: (
            <div>
              <h2 className="toast-title toast-title--failure">
                Coś poszło nie tak...
              </h2>
              <p className="toast-message">{message}</p>
            </div>
          ),
          type: "error",
          isLoading: false,
          closeButton: true,
          autoClose: 3000,
          className: "Toastify__toast--stacked",
        });
        break;
      case TOAST_TYPES_ENUM.LOADING:
        toast.loading("Ładowanie", {
          toastId: id,
          className: "Toastify__toast--stacked",
        });
        break;
      case TOAST_TYPES_ENUM.HIDE:
        toast.dismiss(id);
        break;
      default: {
        console.error(`Niepoprawny typ notyfikacji (${type})`);
      }
    }
  };

  return <>{handleShowToast()}</>;
};

export default Toast;
